import { useEffect, useRef, useState } from 'react';

/**
 * Mäter containerns bredd så att diagrammen kan rita i riktiga pixlar i stället
 * för att skalas via viewBox. Skalning skulle göra text och streckbredder
 * olika stora i olika paneler.
 */
export function useMeasure<T extends HTMLElement>(fallbackWidth = 640): [React.RefObject<T | null>, number] {
  const ref = useRef<T>(null);
  const [width, setWidth] = useState(fallbackWidth);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new ResizeObserver((entries) => {
      const next = entries[0]?.contentRect.width;
      if (next && next > 0) setWidth(next);
    });
    observer.observe(element);
    setWidth(element.clientWidth || fallbackWidth);

    return () => observer.disconnect();
  }, [fallbackWidth]);

  return [ref, width];
}
